// import parseMarketIndexes from 'views/tools/market-indexes/parseData';
// import parseAutomatedReport from 'views/vessel-reports/parseData';

export const parse = (data, params, table) => {
  switch (table) {
    // case 'market-indexes':
    //   return parseMarketIndexes(data, params);
    // case 'vessel_reports_automated':
    //   return parseAutomatedReport(data);

    default:
      return data;
  }
};
